<template>
  <v-form @submit.prevent="save">
    <v-container>
      <v-layout wrap justify-center>
        <v-flex xs12 md8>
          <v-autocomplete
            v-model="userCheckoutForm.users"
            :items="users"
            :loading="userLoading"
            v-validate="'required'"
            :error-messages="errors.first('users')"
            name="users"
            color="indigo"
            hide-no-data
            hide-selected
            clearable
            multiple
            item-text="profile.name"
            return-object
            :label="$t('Pages.Users.title_singular')"
            :placeholder="$t('Common.type_to_search')"
            prepend-icon="mdi-account-group"
          ></v-autocomplete>
        </v-flex>
      </v-layout>
      <v-layout wrap justify-center>
        <v-flex xs12 md8>
          <v-autocomplete
            v-model="userCheckoutForm.workplace"
            :items="workplaces"
            :loading="workplaceLoading"
            v-validate="'required'"
            :error-messages="errors.first('workplaces')"
            name="workplaces"
            color="indigo"
            hide-no-data
            clearable
            item-text="name"
            return-object
            :label="$t('Pages.Workplaces.title_singular')"
            :placeholder="$t('Common.type_to_search')"
            prepend-icon="mdi-briefcase"
          >
            <template slot="item" slot-scope="{item}">
              {{ item.name }}
            </template>
          </v-autocomplete>
        </v-flex>
      </v-layout>
      <v-layout wrap justify-center>
        <v-flex xs12 md8>
          <v-autocomplete
            v-model="userCheckoutForm.warehouse"
            :items="warehouses"
            :loading="warehousesLoading"
            v-validate="'required'"
            :error-messages="errors.first('warehouses')"
            name="warehouses"
            color="indigo"
            hide-no-data
            hide-selected
            clearable
            item-text="name"
            return-object
            :label="$t('Pages.Warehouses.title_singular')"
            :placeholder="$t('Common.type_to_search')"
            prepend-icon="home_work"
            @change="onWarehouseChange()"
          ></v-autocomplete>
        </v-flex>
      </v-layout>
      <template v-if="userCheckoutForm && userCheckoutForm.warehouse">
        <v-layout wrap justify-center>
          <v-flex xs12 md6>
            <v-radio-group v-model="isProductSelected" row>
              <v-radio :label="$t('Pages.Products.title_singular')" :value="true"></v-radio>
              <v-radio :label="$t('Pages.Groupations.title_singular')" :value="false"></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center v-if="isProductSelected">
          <v-flex xs12 md6>
            <v-autocomplete
              @change="userCheckoutForm.groupation = null"
              v-model="userCheckoutForm.product"
              :items="products"
              :loading="productLoading"
              name="products"
              color="indigo"
              hide-no-data
              hide-selected
              clearable
              item-text="name"
              return-object
              :label="$t('Pages.Products.title_singular')"
              :placeholder="$t('Common.type_to_search')"
              prepend-icon="mdi-package-down"
            ></v-autocomplete>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center v-if="userCheckoutForm.product && userCheckoutForm.product.productSizes && isProductSelected">
          <v-flex xs12 md6>
            <v-autocomplete
              v-model="userCheckoutForm.product_size_id"
              :items="userCheckoutForm.product.productSizes"
              :error-messages="errors.first('product_sizes')"
              name="product_sizes"
              color="indigo"
              hide-no-data
              hide-selected
              clearable
              item-text="description"
              item-value="id"
              :label="$t('Pages.ProductSizes.title_singular')"
              :placeholder="$t('Common.type_to_search')"
              prepend-icon="mdi-arrow-expand-horizontal"
            >
              <template slot="selection" slot-scope="{item}">
                {{ item.description }} - {{$t('Pages.WarehouseStates.model.state')}}: <div style="margin-left: 5px" :class="{'red--text': item.state == 0, 'success--text': item.state > 0}"> {{ item.state }} </div>
              </template>
              <template slot="item" slot-scope="{item}">
                {{ item.description }} - {{$t('Pages.WarehouseStates.model.state')}}: <div style="margin-left: 5px" :class="{'red--text': item.state == 0, 'success--text': item.state > 0}"> {{ item.state }} </div>
              </template>

            </v-autocomplete>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center v-if="!isProductSelected">
          <v-flex xs12 md6>
            <v-autocomplete
              @change="userCheckoutForm.product = null; userCheckoutForm.product_size_id = null"
              v-model="userCheckoutForm.groupation"
              :items="groupations"
              :loading="groupationLoading"
              name="groupations"
              color="indigo"
              hide-no-data
              hide-selected
              clearable
              item-text="name"
              return-object
              :label="$t('Pages.Groupations.title_singular')"
              :placeholder="$t('Common.type_to_search')"
              prepend-icon="mdi-account-multiple"
            ></v-autocomplete>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center>
          <v-flex xs12  md6>
            <v-text-field
                    v-validate="'required'"
                    v-model="userCheckoutForm.quantity"
                    :error-messages="errors.first('quantity')"
                    :label="$t('Pages.Products.model.quantity')"
                    type="number"
                    min="1"
                    color="indigo"
                    name="quantity"
            />
          </v-flex>
        </v-layout>
      </template>
      <v-layout wrap justify-center>
        <v-flex xs12 md8>
          <v-dialog
            ref="dialog"
            v-model="modal"
            :return-value.sync="userCheckoutForm.start"
            persistent
            lazy
            full-width
            width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="computedStart"
              :label="$t('Pages.UserCheckoutForms.model.start')"
              v-validate="'required'"
              :error-messages="errors.first('start')"
              prepend-icon="event"
              readonly
              color="indigo"
              clearable
              name="start"
              required
            ></v-text-field>
            <v-date-picker locale="sr-Latn-RS" first-day-of-week="1" color="indigo" v-model="userCheckoutForm.start" scrollable>
              <v-spacer></v-spacer>
              <v-btn flat @click="modal = false">{{$t('Core.Fields.cancel')}}</v-btn>
              <v-btn flat color="indigo" @click="$refs.dialog.save(userCheckoutForm.start)">{{$t('Core.Fields.ok')}}</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-flex>
      </v-layout>
      <v-layout wrap justify-center>
        <v-flex xs12 md8>
          <v-datetime-picker
            :label="$t('Pages.UserCheckoutForms.model.expiration')"
            :error-messages="errors.first('expiration')"
            locale="sr-Latn-RS"
            format="DD/MM/YYYY HH:mm:ss"
            name="expiration"
            prepend-icon="event"
            v-model="userCheckoutForm.expiration" />
        </v-flex>
      </v-layout>
      <v-layout wrap justify-center>
        <v-flex xs12 md8>
          <v-select
            slot="actions-prepend"
            v-model="userCheckoutForm.last_status"
            v-validate="'required'"
            :error-messages="errors.first('status')"
            :label="$t('Pages.UserCheckoutForms.model.status')"
            :items="computedStatuses"
            single-line
            color="purple"
            name="status"
            @change="onStatusChange"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="mt-4 justify-center">
        <v-btn round color="primary" dark type="submit" @click="continueAdding = true" v-if="!edit">
          {{$t('Core.Fields.save_and_continue')}}
        </v-btn>
        <v-btn round color="indigo" dark type="submit">
          {{$t('Core.Fields.save')}}
        </v-btn>
        <v-btn round href="javascript:history.go(-1)">
          {{$t('Core.Fields.back')}}
        </v-btn>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
  import Form from '../../services/Form'
  import _ from 'lodash';
  import moment from 'moment'

  export default {
    components: {},
    props: {
      userCheckoutForm: {
        type: Object,
        required: true
      },
      edit: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      users: [],
      userLoading: false,
      workplaces: [],
      workplaceLoading: false,
      products: [],
      productLoading: false,
      groupations: [],
      groupationLoading: false,
      warehouses: [],
      warehousesLoading: false,
      modal: false,
      modalExpiration: false,
      statuses: [],
      isProductSelected: true,
      currentStatus: null,
      continueAdding: false,
      initial: true
    }),
    computed: {
      computedStart: {
        get() {
          return this.getLocaleDateFormat(this.userCheckoutForm.start);
        },
        set(val) {
          return this.userCheckoutForm.start = val
        }
      },
      // computedExpiration: {
      //   get() {
      //     return this.getLocaleDateFormat(this.userCheckoutForm.expiration);
      //   },
      //   set(val) {
      //     return this.userCheckoutForm.enexpirationd = val
      //   }
      // },
      computedStatuses() {
        this.statuses = this.getAvailableStatuses(this.currentStatus);
        return this.statuses;
      }
    },
    created () {
      if(!this.$route.params.id) {
        this.statuses = this.getAvailableStatuses('', true);
        this.userCheckoutForm.last_status = this.userCheckoutFormStatuses.GIVEN;
      }

      this.getUsers();
      this.getWorkplaces();
      // this.getProducts();
      this.getGroupations();
      this.getWarehouses();
    },
    methods: {
      getUsers(q){
        this.userLoading = true;
        this.repositories.user.all(q, 'workplaces.productRules.product,workplaces.workplaceGroupationRules.groupation').then((response) => {
          this.users = response.data.data;
        }).finally(() => {
          this.userLoading = false;
        });
      },
      getWorkplaces(q){
        this.workplaceLoading = true;
        this.repositories.workplace.all(q, 'productRules.product,workplaceGroupationRules.groupation').then((response) => {
          this.workplaces = response.data.data;
          if(this.userCheckoutForm.users[0]) {
            if(this.workplaces[1].divider) {
              this.workplaces.splice(0,2);
            }
            let array = this.workplaces.filter(workplace => {
              let bool = true;
              this.userCheckoutForm.users[0].workplaces.forEach(el => {
                if(el.id === workplace.id) {
                  bool = false;
                }
              });
              return bool;
            });
            array.unshift({ divider: true });
            this.userCheckoutForm.users[0].workplaces.forEach(el => {
              array.unshift(el);
            });
            this.workplaces = array;
          }
        }).finally(() => {
          this.workplaceLoading = false;
        });
      },
      getStates(){
        this.productLoading = true;
        this.repositories.warehouse.getStates(this.userCheckoutForm.warehouse.id, {include: 'product.productSizes'}).then((response) => {
          var data = response.data.data;
          var products = [];
          data.forEach((item) => {
            if(item.state <= 0 || !item.product) {
              return;
            }
            var id = item.product.id;
            if(!products[id]){
              products[id] = item.product;
              products[id].productSizes = item.product.productSizes;
            }

            if (item.productSize && products[id].productSizes) {
              var productSizes = products[id].productSizes;
              productSizes.forEach((size) => {
                if (size.id == item.productSize.id) {
                  size.state = item.state;
                }

                if(size.state && size.state > 0) {
                  size.disabled = false;
                }
                else{
                  size.disabled = true;
                  size.state = 0;
                }
              });
            }
            products[id].productSizes = productSizes;
          });

          this.products = [];          
          products.forEach((item) => {
            this.products.push(item);
          });
        }).finally(() => {
          this.productLoading = false;
        });
      },
      // getProducts(q){
      //   this.productLoading = true;
      //   this.repositories.product.all(q).then((response) => {
      //     this.products = response.data.data;
      //   }).finally(() => {
      //     this.productLoading = false;
      //   });
      // },
      getGroupations(q){
        this.groupationLoading = true;
        this.repositories.groupation.all(q).then((response) => {
          this.groupations = response.data.data;
        }).finally(() => {
          this.groupationLoading = false;
        });
      },
      getWarehouses(q){
        this.warehousesLoading = true;
        this.repositories.warehouse.all(q, 'warehouseStates').then((response) => {
          this.warehouses = response.data.data;
          if(this.$route.params.id){
            this.getStates();
          }
        }).finally(() => {
          this.warehousesLoading = false;
        });
      },
      onWarehouseChange() {
        if(this.userCheckoutForm && this.userCheckoutForm.warehouse){
          this.getStates();
        }
        this.$emit('refresh')
      },
      save(){
        this.$validator.validateAll().then((result) => {
          if (result) {
            let data = JSON.parse(JSON.stringify(this.userCheckoutForm));
            data.expiration = data.expiration ? moment(data.expiration).format('YYYY-MM-DD HH:mm:ss') : null;
            if(data.product) {
              data.product_id = data.product.id;
            } else {
              data.groupation_id = data.groupation.id;
            }
            //data.user_id = this.userCheckoutForm.user.id;
            data.users = this.userCheckoutForm.users;
            //data.users = [{id:1}, {id:this.userCheckoutForm.users.id}];
            data.workplace_id = this.userCheckoutForm.workplace.id;
            data.warehouse_id = this.userCheckoutForm.warehouse.id;
            data.continue = this.continueAdding;
             this.$emit('save', data);
             this.continueAdding = false;
          }
        });
      },
      updateEndDate() {
        if(this.isProductSelected && this.userCheckoutForm.product && this.userCheckoutForm.workplace && this.userCheckoutForm.workplace.productRules) {
          this.userCheckoutForm.workplace.productRules.forEach(el => {
            if(el.product.id === this.userCheckoutForm.product.id) {
              let hours = null;
              let days = null;
              let months = null;
              if(el.expiration < 24) {
                hours = el.expiration;
              } else if(el.expiration < 720) {
                days = el.expiration / 24;
              } else {
                months = el.expiration / 30 / 24;
              }
              if(this.userCheckoutForm.start) {
                const startYear = this.userCheckoutForm.start;
                const yearStart = Number(startYear.slice(0,4));
                let monthsStart = Number(startYear.slice(5, 7));
                let daysStart = Number(startYear.slice(8, 10));
                let hoursStart = new Date().getHours();
                let minutesStart = 0;
                if(hours) {
                  hoursStart += hours;
                }
                if(days) {
                  daysStart += days;
                }
                if(months) {
                  monthsStart += months;
                }
                this.userCheckoutForm.expiration = new Date(yearStart, monthsStart - 1, daysStart, hoursStart, minutesStart);
              }
            }
          });
        }
        if(!this.isProductSelected && this.userCheckoutForm.groupation_id && this.userCheckoutForm.workplace && this.userCheckoutForm.workplace.workplaceGroupationRules) {
          this.userCheckoutForm.workplace.workplaceGroupationRules.forEach(el => {
            if(el.groupation.id === this.userCheckoutForm.groupation_id) {
              let hours = null;
              let days = null;
              let months = null;
              if(el.expiration < 24) {
                hours = el.expiration;
              } else if(el.expiration < 720) {
                days = el.expiration / 24;
              } else {
                months = el.expiration / 30 / 24;
              }
              if(this.userCheckoutForm.start) {
                const startYear = this.userCheckoutForm.start;
                const yearStart = Number(startYear.slice(0,4));
                let monthsStart = Number(startYear.slice(5, 7));
                let daysStart = Number(startYear.slice(8, 10));
                let hoursStart = new Date().getHours();
                let minutesStart = 0;
                if(hours) {
                  hoursStart += hours;
                }
                if(days) {
                  daysStart += days;
                }
                if(months) {
                  monthsStart += months;
                }
                this.userCheckoutForm.expiration = new Date(yearStart, monthsStart - 1, daysStart, hoursStart, minutesStart);
              }
            }
          });
        }
      },
      onStatusChange() {
        this.$emit('refresh');
      }
    },
    watch: {
      // products: function() {
      //   if(this.edit && this.userCheckoutForm.product) {
      //     this.products.forEach(el => {
      //       if(el.id === this.userCheckoutForm.product.id) {
      //         this.userCheckoutForm.product.productSizes = el.productSizes;
      //       }
      //     })
      //   }
      // },
      userCheckoutForm: function() {
        if (this.userCheckoutForm.groupation) {
          this.isProductSelected = false;
        }
        if(this.initial && this.$route.params.id) {
          this.currentStatus = this.userCheckoutForm ? this.userCheckoutForm.last_status : null;
          this.initial = false;
        }
      },
      isProductSelected: function() {
        if(this.isProductSelected) {
          delete this.userCheckoutForm.groupation;
          delete this.userCheckoutForm.groupation_id;
        } else {
          delete this.userCheckoutForm.product;
          delete this.userCheckoutForm.product_size_id;
        }
      },
      'userCheckoutForm.users': function() {
        this.getWorkplaces();
      },
      'userCheckoutForm.workplace': function() {
        this.updateEndDate();
      },
      'userCheckoutForm.product': function() {
        this.updateEndDate();
      },
      'userCheckoutForm.groupation_id': function() {
        this.updateEndDate();
      },
      'userCheckoutForm.start': function() {
        this.updateEndDate();
      },
      'userCheckoutForm.warehouse': function() {
        if (this.$route.params.id) {
          return;
        }
        if (this.userCheckoutForm.warehouse && this.userCheckoutForm.warehouse.type === this.userCheckoutFormStatuses.EXPENDABLE) {
          this.userCheckoutForm.last_status = this.userCheckoutFormStatuses.EXPENDABLE;
        } else {
          this.userCheckoutForm.last_status = this.userCheckoutFormStatuses.GIVEN;
        }
      },
      'userCheckoutForm.last_status': function() {
        if (!this.$route.params.id && this.userCheckoutForm.last_status === this.userCheckoutFormStatuses.EXPENDABLE) {
          this.userCheckoutForm.warehouse = this.warehouses.find(el => el.type === this.userCheckoutFormStatuses.EXPENDABLE);
        }
      }
    }
  }
</script>

<style lang="scss">

</style>
